import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { t } from '../../../../../../modules/infra/i18n';
import Tooltip from '../../../../../common/tooltip';
import CheckboxSwitch from '../../../../../common/checkboxSwitch';
import Select from '../../../../../common/select';
import ChangeFulfillmentConfirmation from '../ChangeFulfillmentConfirmation';
import Icon, { GLYPHS } from '../../../../../common/icon';

const ShopifySettingsForm = ({
  connectedTo,
  confirmationIsOn,
  confirmationOff,
  handleSubmit,
  locations,
  remoteLocations,
  shopifySettings,
  submit,
}) => {
  const connectedAccountName = shopifySettings.shopIdentifier;
  const canDisplayConnectionCards = !!(connectedTo && connectedAccountName);

  return (
    <>
      <div display-if={canDisplayConnectionCards} className="shopify-settings-page__body__state">
        <div className="shopify-state-card">
          <strong>{t('settings:integrations.shopify.status_label')}</strong>
          <div>
            <Icon glyph={GLYPHS.checkMarkBlue} className="o-icon--micro" />
            {connectedTo}
          </div>
        </div>
        <div className="shopify-state-card">
          <strong>{t('settings:integrations.shopify.connected_account_name')}</strong>
          <div>
            <Icon glyph={GLYPHS.checkMarkBlue} className="o-icon--micro" />
            {connectedAccountName}
          </div>
        </div>
      </div>
      <form
        className="shopify-settings-form"
        data-automation-id="shopify-settings-form"
        id="shopify-settings-form"
        onSubmit={handleSubmit}
      >
          <div className="u-mt- u-mb- o-flexbox o-flexbox--justify-start o-flexbox--content-align-center">
            <div className="shopify-settings-form__text">
            {t('settings:integrations.shopify.fulfillment_location')}
            <Tooltip
              className="c-info-tooltip-new--small"
              text={t('settings:integrations.shopify.fulfillment_tooltip')}
            />
            </div>
          </div>
        <label htmlFor="locationId">{t('settings:integrations.shopify.squire_inventory_address')}</label>
          <Select className="c-select" name="locationId" options={locations} />
          <div className="u-mt-">
          <label htmlFor="remoteLocationId">{t('settings:integrations.shopify.shopify_inventory_address')}</label>
            <Select className="c-select u-mb-" name="remoteLocationId" options={remoteLocations} />
          </div>
          <div className="u-mt- u-mb o-flexbox o-flexbox--justify-space-between o-flexbox--content-align-center">
            <div className="shopify-settings-form__text">
            {t('settings:integrations.shopify.reconcile_inventory_from')}
            <Tooltip
              className="c-info-tooltip-new--small"
              text={t('settings:integrations.shopify.reconcile_tooltip')}
            />
            </div>
            <div className="shopify-settings-form__radio">
              <label className="c-radio" htmlFor="primarySourceSquire">
                <Field
                  id="primarySourceSquire"
                  name="primarySource"
                  component="input"
                  type="radio"
                  className="c-radio__input"
                  value="squire"
                />
                <span className="c-radio__trigger" />
                <span className="c-radio__label">Squire</span>
              </label>
              <label className="c-radio" htmlFor="primarySourceShopify">
                <Field
                  id="primarySourceShopify"
                  name="primarySource"
                  component="input"
                  type="radio"
                  className="c-radio__input"
                  value="vendor"
                />
                <span className="c-radio__trigger" />
                <span className="c-radio__label">Shopify</span>
              </label>
            </div>
          </div>
          <div className="u-mt u-mb o-flexbox o-flexbox--justify-space-between o-flexbox--content-align-center">
            <div className="shopify-settings-form__text">
            {t('settings:integrations.shopify.price_sync')}
            <Tooltip
              className="c-info-tooltip-new--small"
              text={t('settings:integrations.shopify.price_sync_tooltip')}
            />
            </div>
            <div className="shopify-settings-form__checkbox">
            <CheckboxSwitch name="enablePriceSync" id="enablePriceSync" />
            {t('settings:integrations.shopify.active_label')}
          </div>
          </div>
          <ChangeFulfillmentConfirmation
            connectedProductsCount={10}
            onSubmit={submit}
            openedIsOn={confirmationIsOn}
            openedOff={confirmationOff}
          />
        </form>
    </>
  );
};

ShopifySettingsForm.propTypes = {
  connectedTo: PropTypes.string,
  confirmationIsOn: PropTypes.bool.isRequired,
  confirmationOff: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  remoteLocations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  shopifySettings: PropTypes.shape({
    shopIdentifier: PropTypes.string,
  }).isRequired,
  submit: PropTypes.func.isRequired,
};

ShopifySettingsForm.defaultProps = {
  connectedTo: undefined,
};

export default ShopifySettingsForm;
